import { render, staticRenderFns } from "./SecurityKey.vue?vue&type=template&id=2162cdbf"
import script from "./SecurityKey.vue?vue&type=script&lang=ts"
export * from "./SecurityKey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports